(function($) {
    $(document).ready(function() {
        if ((".js_research_teams_fellow .col-four-video, #audio-podcasts").length > 0) {
            var len = $('.col-four-video .col-four').length;
            if (len > 11) {
                $('.col-four-video .col-four', this).eq(10).nextAll().hide();
                $('.col-four-video .btn-wrapper').show();
            } else {
                $('.col-four-video .btn-wrapper').hide();
            }

        }
        if (!$(".col-four-video").hasClass("col-four-video-carousel") && $(".col-four-video.col-four-video-grid .row-wrap .col-four").length > 9) {
            $(".col-four-video .row-wrap .col-four").addClass("item");
            setTimeout(function() {
                $(".col-four-video .row-wrap .col-four:nth-child(1)").removeClass("item");
                $(".col-four-video .row-wrap .col-four:nth-child(2)").removeClass("item");
                $(".col-four-video .row-wrap .col-four:nth-child(3)").removeClass("item");
                $(".col-four-video .row-wrap .col-four:nth-child(4)").removeClass("item");
                $(".col-four-video .row-wrap .col-four:nth-child(5)").removeClass("item");
                $(".col-four-video .row-wrap .col-four:nth-child(6)").removeClass("item");
                $(".col-four-video .row-wrap .col-four:nth-child(7)").removeClass("item");
                $(".col-four-video .row-wrap .col-four:nth-child(8)").removeClass("item");
            }, 200);
            setTimeout(function() {
                $(".col-four-video .row-wrap .col-four.item").wrapAll('<div class="item-outer"></div>');
            }, 400);
        }


        // $(".col-four-video.col-four-video-grid .row-wrap").addClass("active show");
        $("#exploreresearch .row-wrap").addClass("active show");

        $(document).on("click", ".col-four-video .link-more span", function(e) {
            // $(".col-four-video .row-wrap").addClass("active");
            $('.col-four-video .btn-wrapper').show();
            // $('.col-four-video .col-four').hide();
            $('.col-four-video .btn-wrapper .link-more').show();
            var className = $(this).text();
            if (className == "View More") {
                $(this).text('View Less');
                $(this).addClass("active");
                $(".col-four-video .row-wrap").removeClass("show");
                $(".col-four-video.col-four-video-grid .row-wrap .item-outer").slideDown();
            } else {
                $(this).text('View More');
                $(".col-four-video.col-four-video-grid .row-wrap .item-outer").slideUp();
                $(this).removeClass("active");
                $(".col-four-video .row-wrap").addClass("show");
            }
        });


        $(".col-four-video .btn-wrapper .link-more a").click(function(e) {
            e.preventDefault();
        });
        
        $(document).on('click', '.col-four-video#audio-podcasts .btn-wrapper .link-more a', function() {
            headerHeight = $(".col-four-video#audio-podcasts").offset().top + $("header").outerHeight();
            $("html, body").animate({
                    scrollTop: headerHeight,
                },
                500,
                "linear"
            );
        });

    });
    $(window).on('load', function() {
        if ($('.js_research_teams_fellow .col-four-video, #audio-podcasts').length > 0) {
            $(".js_research_teams_fellow .col-four-video .row-wrap").addClass("active show");
            pagination(".col-four-video .col-four", ".col-four-video .link-more", 12, 8);

            function pagination(divPath, buttonPath, initial_Count, show_div_on_click) {
                var divCount = $(divPath).length;
                var showDiv = initial_Count;
                show_div_on_click = show_div_on_click + 0;
                $(divPath).hide();
                $(divPath + ':lt(' + showDiv + ')').show();
                if (showDiv == divCount) {
                    $(buttonPath).hide();
                }
                $(document).on("click", buttonPath, function() {
                    showDiv = (showDiv + show_div_on_click <= divCount) ? showDiv + show_div_on_click : divCount;
                    $(divPath + ':lt(' + showDiv + ')').show();
                    $('#showLess').show();
                    if (showDiv == divCount) {
                        $(buttonPath).hide();
                    }
                });
            }
        }
    });
})(jQuery);